export default __webpack_public_path__ + "media/images/logo_dark_multicolor-dc9e97127e77264893c32f0dc55409d1.png";